// extracted by mini-css-extract-plugin
module.exports = {"subslide":"slide-subslide_subslide_2qqXE","subslideVisible":"slide-subslide_subslideVisible_pIrcJ"};